module.exports = __webpack_public_path__ + "img/map-maker.1d4aa69f.svg";